/**
 * @file
 * A JavaScript file containing the footer functionality (small/large screen)
 *
 */

/**
 * Enter Espoo JS.
 */
(function (Drupal, $) {
  Drupal.behaviors.footer = {
    attach: function (context) {
      init();
    }
  };

  function init() {
    scrollToTopTrigger();
    wrapSoMeIcons();
  }

  function wrapSoMeIcons() {
    let footerBlocks = $('.footer__column.footer__block');

    footerBlocks.each(function(key, item) {
      detectSoMe(key, item);
    });
  }

  function detectSoMe(key, block) {
    if ($(block).find('a.some').length > 0) {
      $(block).addClass('some-icons');
    }
  }

  function scrollToTopTrigger() {
    let button = $(".chevron-wrapper");
    Drupal.behaviors.utils.scrollTrigger(button, "up");
  }

})(Drupal, jQuery);
